import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { providerCapability } from "../_types/provider-capability.model";
import { providerCase } from "../_types/provider-case.model";

@Injectable({
    providedIn: 'root',
})
export class ProviderCasesService extends Service<providerCase> {
  public override type = 'providerCases';
  public override url = 'providers/providerCases'; 
}